// A reusable utility wrapper for all localStorage operations
export const localStorageActions = {
  // Generic set function: stores any type of value under a given key
  set<T>(key: string, value: T) {
    try {
      // Convert value to JSON string before saving
      const serialized = JSON.stringify(value);

      // Save serialized data in localStorage
      localStorage.setItem(key, serialized);
    } catch (error) {
      // Catch JSON or localStorage errors (e.g., quota exceeded)
      console.error('LocalStorage set error:', error);
    }
  },

  // Generic get function: reads a stored value and converts it back to object/primitive
  get<T>(key: string): T | null {
    try {
      // Read value from localStorage
      const item = localStorage.getItem(key);

      // If item exists, parse JSON → return typed value
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      // If parsing fails or item is corrupted
      console.error('LocalStorage get error:', error);
      return null;
    }
  },

  // Remove a specific key from localStorage
  remove(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('LocalStorage remove error:', error);
    }
  },

  // Check whether a key already exists in localStorage
  exists(key: string) {
    return localStorage.getItem(key) !== null;
  }
};

// Centralized storage keys used across the app
export const storageKeys = {
  // Store user's last selected tenant ID on change from header tenant switcher.
  LAST_LOGIN_TENANT_ID: 'last_login_tenantId'
};
